import { Company, Loan, Note, Participation, TCompanyId } from '/src/lib/models';
import { TCreateParticipationRequest } from '/src/lib/types';

/**
 * Enums
 */
export enum PaymentMethod {
  None = 'None',
  SetAmount = 'Set Amount',
  FeesAndInterest = 'Fees + Interest',
  PayDown = 'Pay Down',
}

export enum LoanStatus {
  Active = 'active',
  Inactive = 'inactive',
  PaidOff = 'paid-off',
}

export enum LoanType {
  Loan = 'Loan Deal',
  Owned = 'Owned Deal',
}

/**
 * List Loans
 */
export type TListLoansRequest = {
  companyId?: TCompanyId;
};

export type TListLoansResponse = Loan[];

/**
 * Get Loan
 */
export type TGetLoanResponse = Loan;

/**
 * Get Loan Name
 */
export type TGetLoanNameResponse = string;

/**
 * Create Loan
 */
export type CreateLoanForm = {
  name: string;
  borrower?: Company;
  isOwned?: boolean;
  dealType?: LoanType; // this turns into `isOwned`
  amount: number;
  interestRate: number;
  advanceRate: number;
  originationFee: number;
  term: number;
  maturityDate?: Date;
  lastAdvanceDate?: Date;
  minPmtMethod?: PaymentMethod;
  minimumPayment: number;
  status: LoanStatus;
  socketComments: Note[];
  companyComments: Note[];
  files: string[];
  principalDateUpdated: Date;
  lenders: TCreateParticipationRequest[];
  adminFee: number;
  discountFee: number;
  // managementFee: number;
  // participationPercentage: number;
  // totalParticipation: number;
  payDownPercent: number;
};

export type TCreateLoanRequest = {
  name: string;
  borrower: Company;
  isOwned: boolean;
  amount: number;
  interestRate: number;
  advanceRate: number;
  originationFee: number;
  term: number; // in months
  maturityDate: Date;
  lastAdvanceDate: Date;
  minPmtMethod: PaymentMethod;
  minimumPayment: number;
  payDownPercent: number;
  status: LoanStatus;
  socketComments: Note[];
  companyComments: Note[];
  files: string[];
  feeBalance: number;
  adminFee: number;
  discountFee: number;
  interestBalance: number;
  principalBalance: number;
  principalDateUpdated: Date;
  assetValue: number;
  lenders: Participation[];
};

export type TCreateLoanResponse = Loan;

/**
 * Update Loan
 */
export type TUpdateLoanRequest = Loan;

export type TUpdateLoanResponse = Loan;

/**
 * Delete Loan
 */
export type TDeleteLoanResponse = Loan;
